import { Pipe, PipeTransform } from '@angular/core';
import { HotspotType } from './hotspot-type.model';

@Pipe({
  name: 'hotspotType'
})
export class HotspotTypePipe implements PipeTransform {

  transform(value: HotspotType, args?: any): any {
    const result = value.toString().toLowerCase().replace('_', ' ');
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

}
